import { LogPullerTypeEnum } from 'Generated/schema';
import { LogSourceType, DESTINATIONS, EnrichmentSourcesEnum } from 'Source/constants';
import urls from 'Source/urls';

export const alertDestinationsUrls = [
  urls.configure.alertDestinations.create(),
  urls.configure.alertDestinations.create(':name' as keyof typeof DESTINATIONS),
  urls.configure.alertDestinations.edit(':id'),
  urls.configure.alertDestinations.list(),
  `${urls.configure.alertDestinations.list()}:id`,
];

export const cloudAccountsUrls = [
  urls.configure.cloudAccounts.create(),
  urls.configure.cloudAccounts.edit(':id'),
  urls.configure.cloudAccounts.list(),
  `${urls.configure.cloudAccounts.list()}:id`,
];

export const enrichmentProvidersRoutesUrls = [
  urls.configure.enrichmentProviders.details(':id'),
  urls.configure.enrichmentProviders.list(),
  urls.configure.enrichmentProviders.edit(':id'),
  urls.configure.enrichmentProviders.create(),
  urls.configure.enrichmentProviders.create(':type' as EnrichmentSourcesEnum),
];

export const logSourcesUrls = [
  urls.configure.home(),
  urls.configure.logSources.authorize(':id', ':type' as LogPullerTypeEnum),
  urls.configure.logSources.create(),
  urls.configure.logSources.create(':type' as LogSourceType),
  urls.configure.logSources.details(':id'),
  urls.configure.logSources.edit(':id'),
  urls.configure.logSources.list(),
  `${urls.configure.logSources.list()}:type`,
  urls.configure.logSources.schemasManagement(':id').home(),
  urls.configure.logSources.schemasManagement(':id').draftSchema(':schemaName'),
  urls.configure.logSources.schemasManagement(':id').testReport(':testReport'),
];

export const schemasUrls = [
  urls.configure.schemas.create(),
  urls.configure.schemas.details(':name'),
  urls.configure.schemas.edit(':name'),
  urls.configure.schemas.list(),
];

export const contentCatalogUrls = [
  urls.contentCatalog.home(),
  urls.contentCatalog.browse(),
  urls.contentCatalog.installed(),
  urls.contentCatalog.workbench(),
];

export const configureUrlsGroup = [
  ...alertDestinationsUrls,
  ...cloudAccountsUrls,
  ...enrichmentProvidersRoutesUrls,
  ...logSourcesUrls,
  ...schemasUrls,
];
